<script>
import * as BABYLON from 'babylonjs'
import 'babylonjs-materials'

export default {
  name: 'UpSideDown',
  render: (h) => h(),
  beforeDestroy() {
    if(this.$skybox2) this.$skybox2.dispose()
    if(this.$fountain) this.$fountain.dispose()
    if(this.$gradient) this.$gradient.dispose()
    if(this.$particle) this.$particle.dispose()
  },
  created() {
    TweenLite.delayedCall(2, this.create)
  },
  methods: {
    create() {
      const meshs = this.$meshs = this.$parent.$meshs
      const scene = this.$scene = this.$parent.$scene
      const camera = this.$camera = this.$parent.$camera

      this.$camera.rotation = new BABYLON.Vector3(0, -6.3, 0)

      // skybox
      var skybox = BABYLON.MeshBuilder.CreateBox("skyBox", {size: 20000.0}, scene)
      var skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene)
          skyboxMaterial.backFaceCulling = false
          skyboxMaterial.reflectionTexture = this.$root.galaxyTexture
          skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE
          skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0)
          skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0)
          skyboxMaterial.alpha = 1
          skybox.material = skyboxMaterial
      TweenMax.to(skybox.rotation, 1000, { y: 2, repeat: -1, yoyo: true })
      this.$skybox = skybox

      // gradient
      var m = new BABYLON.StandardMaterial("m", scene)
          m.diffuseTexture = new BABYLON.Texture(require('./img/gradient.png'), scene)
          m.opacityTexture = m.diffuseTexture
          m.emissiveTexture = m.diffuseTexture
          m.backFaceCulling = false
      this.$gradient = BABYLON.MeshBuilder.CreateSphere("sphere", { diameter: 2000 }, scene)
      this.$gradient.material = m

      // keep
      this.keep = [
        // 'TN_floor_MAT_tunnel_floor_0',
        // 'MR_floor_MAT_MR_floor_0',
        // 'SR_floorPapers_MAT_SR_floorPapers_0',
        // 'SR_floor_MAT_SR_floor_0',

        'TN_floor',
        'MR_floor',
        'SR_floor',
        'SR_floorPapers',
        'MR_Grey'
      ]

      // const color = new BABYLON.Color3(.1, .1, .1)
      // const matFloor = new BABYLON.StandardMaterial('upsidedown_floor', this.$scene)
      //       matFloor.backFaceCulling = false
      //       matFloor.diffuseColor = color
      //       matFloor.emissiveColor = color
      //       matFloor.reflectionTexture = _.clone(skyboxMaterial.reflectionTexture)
      //       matFloor.reflectionTexture.coordinatesMode = BABYLON.Texture.PLANAR_MODE

      var water = new BABYLON.WaterMaterial("water", scene, new BABYLON.Vector2(512, 512))
          water.backFaceCulling = true
          water.bumpTexture = new BABYLON.Texture(require('./img/waterbump.png'), scene)
          // water.windForce = 10
          // water.waveHeight = 2.3
          // water.bumpHeight = 0.25
          // water.windDirection = new BABYLON.Vector2(1, 1)
          // water.waterColor = new BABYLON.Color3(.1, .1, .1)
          water.colorBlendFactor = .1
          water.alphaMode = BABYLON.Engine.ALPHA_PREMULTIPLIED
          water.backFaceCulling = false
          water.addToRenderList(skybox)

      _.each(this.$meshs, mesh => {
        if(mesh.material) {
          if(mesh.name.substring(0, 2) == 'o_' || mesh.name.substring(0, 2) == 'c_')
            return
          if(this.keep.indexOf(mesh.name) > -1)
            return mesh.material = _.clone(water)
          mesh.dispose()
        }
      })

      //
      const fountain = new BABYLON.MeshBuilder.CreateBox('Machine', { width: 1, depth: 1, height: 1 }, this.$scene)
            fountain.parent = camera
            fountain.position.z = -1

      const particleSystem = new BABYLON.ParticleSystem("particles", 2000, this.$scene)
            particleSystem.particleTexture = new BABYLON.Texture(require('./img/flare.png'), this.$scene)
            particleSystem.emitter = fountain

            particleSystem.colorDead = new BABYLON.Color4(0.8, 0.5, 1.0, 0.0);
            particleSystem.minEmitBox = new BABYLON.Vector3(-100, -10, -100)
            particleSystem.maxEmitBox = new BABYLON.Vector3(100, 10, 100)
            particleSystem.minSize = 0.1
            particleSystem.maxSize = 0.5
            particleSystem.minLifeTime = 5.3
            particleSystem.maxLifeTime = 10.5
            particleSystem.emitRate = 1000
            particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ONEONE
            particleSystem.gravity = new BABYLON.Vector3(0, -50, 0)
            particleSystem.minAngularSpeed = 0
            particleSystem.maxAngularSpeed = Math.PI
            particleSystem.minEmitPower = 1
            particleSystem.maxEmitPower = 30
            particleSystem.updateSpeed = 0.005
            particleSystem.start()

      this.$particle = particleSystem
      this.$fountain = fountain
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/UpSideDown.vue